var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.693,
    height: 17.986,
    viewBox: "0 0 12.693 17.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22378",
    "data-name": "Group 22378",
    transform: "translate(-1463.193 -751.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29068",
    "data-name": "Path 29068",
    d: "M21.65,32.759a.529.529,0,0,0,.528.528H33.815a.528.528,0,0,0,0-1.055h-.447a10.174,10.174,0,0,0-.1-3.452,4.075,4.075,0,0,0-1.524-2.386l-2.725-2.1,2.725-2.1a4.1,4.1,0,0,0,1.529-2.4,10.342,10.342,0,0,0,.1-3.436h.447a.528.528,0,0,0,0-1.055H22.178a.528.528,0,0,0,0,1.055h.447a10.174,10.174,0,0,0,.1,3.452,4.075,4.075,0,0,0,1.524,2.386l2.725,2.1-2.725,2.1a4.1,4.1,0,0,0-1.529,2.4,10.342,10.342,0,0,0-.1,3.436h-.447A.529.529,0,0,0,21.65,32.759Zm2.014-13.732a9.03,9.03,0,0,1,.016-2.666h8.632A9.068,9.068,0,0,1,32.329,19H23.761a.693.693,0,0,0-.1.022Zm1.228,8.212L28,24.842l3.107,2.4a3.076,3.076,0,0,1,.991,1.292H23.906a3.055,3.055,0,0,1,.991-1.292Z",
    transform: "translate(1441.543 735.801)",
    fill: "#170A33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/Duration.7133d6d6d59e6f33fa220c9bf96ea7ef.svg";
export { ForwardRef as ReactComponent };